import { useAcsFetch } from '../hooks/use-acs-fetch'

/* Todo: update typings and fix down stream test coverage impacts
(will require some extra null checking in TransactionHistoryTable) */
export const useTransactionHistoryApi = (): any => {
  const acsFetch = useAcsFetch()

  const fetchTransactionHistory = async (payload: any): Promise<any> => {
    const response = await acsFetch(`/v1/bank-accounts/transactions/search`, {
      method: 'POST',
      body: payload,
    })
    return response.data
  }

  return {
    fetchTransactionHistory,
  }
}
